// Central definition of the paths the listing scripts navigate to and call.
// Kept out of the page scripts so the routes live in one place.

export const routes = {
  listing: '/aanbod',
  searchApi: '/web-api/listings/search',
  markerApi: '/web-api/listings/marker',
  detailApi: '/web-api/listings',
  suggestApi: '/web-api/suggest',
  projects: '/projecten',
  projectsSearchApi: '/web-api/projects/search',
  projectsDetailApi: '/web-api/projects'
};
